namespace GeniuzPOS.Inventory {
    export namespace IcStockDisassembleDtService {
        export const baseUrl = 'Inventory/IcStockDisassembleDt';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<IcStockDisassembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<IcStockDisassembleDtRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Inventory/IcStockDisassembleDt/Retrieve",
            List = "Inventory/IcStockDisassembleDt/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>IcStockDisassembleDtService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
